import { track } from "cosmos";
export const cosmosTrackService = (eventName, properties = {}) => {

  if (!eventName) return;
  let commonObj = {};

  commonObj = {
    cp_user_id: localStorage.getItem('cpUserId'),
    user_name: localStorage.getItem('cpUserName'),
    user_type: localStorage.getItem('cpUserType'),
   

    cp_sdk_source : localStorage.getItem('deviceType'),
            
    org_code: localStorage.getItem('cpOrgCode'),
    org_id: localStorage.getItem('cpOrgId'),
    org_name: localStorage.getItem('cpOrgName')
   

  }

track(eventName, {
    ...properties,
    ...commonObj,
  });
};

export function getEvenUserId(id) {
  return Number(id) % 2 == 0 ? true : false;
}
